import { useCallback } from "react";
import { supabase } from "@/shared/lib/supabase";
import type { EmailOtpType } from "@supabase/supabase-js";

export function useAuth() {
  const signOut = useCallback(async () => {
    await supabase.auth.signOut();
  }, []);

  const signInWithPassword = useCallback(
    async (email: string, password: string) => {
      const { error } = await supabase.auth.signInWithPassword({
        email,
        password,
      });
      if (error) return { error: error.message };
      return {};
    },
    [],
  );

  const signInWithOTP = useCallback(
    async (token: string, type: EmailOtpType) => {
      const { error } = await supabase.auth.verifyOtp({
        token_hash: token,
        type: type,
      });
      if (error) return { error: error.message };
      return {};
    },
    [],
  );

  const requestPasswordReset = useCallback(async (email: string) => {
    const { error } = await supabase.auth.resetPasswordForEmail(email, {
      redirectTo: window.location.origin + "/reset-password/confirm",
    });
    if (error) return { error: error.message };
    return {};
  }, []);

  const updatePassword = useCallback(async (newPassword: string) => {
    const { error } = await supabase.auth.updateUser({
      password: newPassword,
    });
    if (error) return { error: error.message };
    return {};
  }, []);

  return {
    signOut,
    signInWithPassword,
    signInWithOTP,
    requestPasswordReset,
    updatePassword,
  };
}
